var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "synergy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "305.25px",
    height: "43.761px",
    viewBox: "0 0 305.25 43.761",
    enableBackground: "new 0 0 305.25 43.761",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.272,
    y1: 8.2061,
    x2: 10.272,
    y2: 31.9663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M4.926,26.399c0.353,0.572,0.814,1.027,1.386,1.364c0.572,0.338,1.217,0.579,1.936,0.726 c0.719,0.147,1.459,0.221,2.222,0.221c0.587,0,1.203-0.044,1.849-0.132c0.645-0.089,1.238-0.249,1.782-0.484 c0.542-0.234,0.99-0.579,1.342-1.034c0.352-0.454,0.528-1.034,0.528-1.738c0-0.968-0.367-1.7-1.1-2.199 c-0.733-0.499-1.65-0.902-2.75-1.21c-1.1-0.309-2.296-0.587-3.586-0.836c-1.291-0.249-2.486-0.602-3.586-1.057 c-1.101-0.454-2.018-1.092-2.75-1.914c-0.734-0.82-1.101-1.965-1.101-3.432c0-1.144,0.257-2.126,0.771-2.948 c0.513-0.821,1.173-1.488,1.979-2.002C4.654,9.211,5.564,8.829,6.576,8.58C7.588,8.331,8.593,8.206,9.59,8.206 c1.291,0,2.479,0.109,3.564,0.33c1.084,0.22,2.046,0.602,2.882,1.144c0.836,0.543,1.503,1.276,2.002,2.2 c0.498,0.924,0.792,2.075,0.88,3.454h-3.74c-0.059-0.733-0.249-1.342-0.572-1.826c-0.323-0.484-0.733-0.873-1.232-1.166 c-0.499-0.293-1.049-0.506-1.65-0.638c-0.602-0.132-1.21-0.198-1.826-0.198c-0.558,0-1.122,0.044-1.694,0.132 C7.632,11.726,7.111,11.88,6.642,12.1c-0.47,0.22-0.851,0.514-1.144,0.88c-0.294,0.367-0.44,0.844-0.44,1.43 c0,0.646,0.227,1.181,0.682,1.606c0.454,0.426,1.034,0.777,1.738,1.056c0.704,0.279,1.496,0.513,2.376,0.704 c0.88,0.191,1.76,0.39,2.64,0.594c0.938,0.206,1.854,0.455,2.75,0.748c0.895,0.293,1.687,0.682,2.376,1.166 c0.688,0.484,1.246,1.093,1.672,1.826c0.425,0.733,0.638,1.644,0.638,2.729c0,1.379-0.286,2.522-0.857,3.432 c-0.572,0.91-1.32,1.644-2.244,2.2c-0.924,0.558-1.966,0.946-3.124,1.166c-1.159,0.22-2.31,0.33-3.454,0.33 c-1.262,0-2.464-0.132-3.608-0.396c-1.144-0.264-2.156-0.696-3.036-1.298c-0.88-0.601-1.584-1.393-2.112-2.376 c-0.528-0.982-0.822-2.178-0.88-3.586h3.74C4.383,25.131,4.574,25.828,4.926,26.399z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.811,
    y1: 8.7334,
    x2: 30.811,
    y2: 40.5464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M30.261,37.29c-0.425,0.762-0.895,1.386-1.408,1.87c-0.514,0.483-1.078,0.836-1.694,1.056 s-1.35,0.33-2.2,0.33c-0.439,0-0.88-0.029-1.32-0.088c-0.44-0.06-0.866-0.162-1.276-0.309v-3.432 c0.352,0.117,0.711,0.234,1.078,0.352c0.366,0.117,0.74,0.177,1.122,0.177c0.762,0,1.378-0.177,1.848-0.528 c0.469-0.353,0.88-0.865,1.232-1.54l1.54-3.828L20.163,8.733h4.224l6.644,18.612h0.088l6.38-18.612h3.96l-9.899,25.74 C31.119,35.588,30.686,36.526,30.261,37.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.2598,
    y1: 8.2061,
    x2: 53.2598,
    y2: 31.4819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M47.364,8.733v3.608h0.088c1.555-2.757,4.019-4.136,7.392-4.136c1.496,0,2.743,0.205,3.74,0.616 c0.997,0.411,1.804,0.983,2.42,1.716c0.616,0.734,1.049,1.606,1.298,2.618s0.374,2.134,0.374,3.366v14.96h-3.74V16.082 c0-1.408-0.411-2.522-1.232-3.344c-0.821-0.821-1.951-1.232-3.388-1.232c-1.145,0-2.134,0.176-2.97,0.528 c-0.836,0.352-1.533,0.851-2.09,1.496c-0.558,0.646-0.976,1.401-1.254,2.266c-0.279,0.865-0.418,1.812-0.418,2.838v12.848h-3.74 V8.733H47.364z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.6968,
    y1: 8.2061,
    x2: 76.6968,
    y2: 31.9663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M83.532,30.029c-1.702,1.292-3.843,1.937-6.424,1.937c-1.819,0-3.396-0.294-4.73-0.88 c-1.335-0.587-2.457-1.408-3.366-2.464c-0.909-1.057-1.592-2.317-2.046-3.784c-0.455-1.467-0.712-3.065-0.77-4.796 c0-1.73,0.264-3.314,0.792-4.752s1.269-2.685,2.222-3.74c0.953-1.056,2.082-1.877,3.388-2.464c1.305-0.587,2.735-0.88,4.29-0.88 c2.024,0,3.703,0.418,5.038,1.254c1.334,0.836,2.405,1.899,3.212,3.189c0.807,1.292,1.364,2.699,1.672,4.225 c0.309,1.525,0.433,2.978,0.374,4.355H70.156c-0.03,0.998,0.088,1.943,0.352,2.838c0.264,0.896,0.689,1.688,1.276,2.376 c0.586,0.689,1.334,1.24,2.244,1.65c0.909,0.411,1.98,0.616,3.212,0.616c1.584,0,2.882-0.367,3.894-1.101 c1.012-0.732,1.679-1.848,2.002-3.344h3.696C86.333,26.817,85.232,28.739,83.532,30.029z M82.63,15.422 c-0.338-0.792-0.792-1.474-1.364-2.046c-0.572-0.572-1.247-1.026-2.024-1.364c-0.777-0.337-1.635-0.506-2.574-0.506 c-0.968,0-1.841,0.169-2.618,0.506c-0.777,0.338-1.445,0.8-2.002,1.386c-0.558,0.587-0.998,1.27-1.32,2.046 c-0.323,0.778-0.513,1.606-0.572,2.486h13.068C83.165,17.05,82.967,16.214,82.63,15.422z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.437,
    y1: 8.2007,
    x2: 96.437,
    y2: 31.4819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M93.973,8.733v4.796h0.088c0.909-1.848,2.024-3.212,3.344-4.092c1.32-0.88,2.992-1.29,5.017-1.231 v3.96c-1.496,0-2.772,0.205-3.828,0.616c-1.056,0.411-1.907,1.012-2.552,1.804c-0.646,0.792-1.115,1.753-1.408,2.882 c-0.294,1.129-0.44,2.428-0.44,3.894v10.12h-3.74V8.733H93.973z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.5522,
    y1: 8.2061,
    x2: 113.5522,
    y2: 40.6782
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M121.428,37.905c-1.701,1.849-4.371,2.772-8.008,2.772c-1.056,0-2.134-0.117-3.234-0.352 c-1.1-0.235-2.098-0.616-2.992-1.145c-0.896-0.528-1.636-1.218-2.223-2.068s-0.909-1.892-0.968-3.124h3.74 c0.029,0.675,0.242,1.247,0.638,1.717c0.396,0.469,0.88,0.85,1.452,1.144c0.572,0.293,1.195,0.506,1.87,0.638 c0.674,0.133,1.32,0.198,1.936,0.198c1.232,0,2.273-0.213,3.124-0.638c0.85-0.426,1.554-1.012,2.112-1.76 c0.557-0.748,0.96-1.65,1.21-2.706c0.249-1.057,0.374-2.215,0.374-3.477v-1.496h-0.088c-0.646,1.408-1.621,2.442-2.926,3.103 c-1.306,0.66-2.692,0.99-4.158,0.99c-1.702,0-3.183-0.309-4.444-0.925c-1.261-0.615-2.317-1.444-3.168-2.485 s-1.489-2.259-1.914-3.652c-0.425-1.393-0.638-2.867-0.638-4.422c0-1.349,0.176-2.735,0.528-4.158 c0.352-1.422,0.938-2.713,1.76-3.872c0.821-1.158,1.906-2.112,3.256-2.86c1.349-0.748,3.007-1.122,4.972-1.122 c1.437,0,2.757,0.315,3.96,0.945c1.203,0.631,2.141,1.577,2.816,2.838h0.044V8.733h3.52v20.813 C123.98,33.271,123.129,36.058,121.428,37.905z M116.654,27.676c0.864-0.513,1.562-1.188,2.09-2.024 c0.528-0.836,0.916-1.781,1.166-2.838c0.249-1.056,0.374-2.111,0.374-3.168c0-0.997-0.118-1.979-0.352-2.948 c-0.235-0.968-0.609-1.84-1.122-2.618c-0.514-0.777-1.181-1.4-2.002-1.87c-0.822-0.469-1.819-0.704-2.992-0.704 c-1.203,0-2.229,0.228-3.08,0.682c-0.852,0.455-1.548,1.063-2.09,1.826c-0.543,0.763-0.939,1.643-1.188,2.64 c-0.25,0.998-0.374,2.039-0.374,3.124c0,1.027,0.103,2.054,0.308,3.08c0.205,1.027,0.557,1.958,1.056,2.794 c0.498,0.836,1.158,1.512,1.979,2.024c0.821,0.514,1.849,0.77,3.08,0.77C114.74,28.445,115.789,28.189,116.654,27.676z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.0347,
    y1: 8.7334,
    x2: 137.0347,
    y2: 40.5464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M136.484,37.29c-0.426,0.762-0.895,1.386-1.408,1.87c-0.514,0.483-1.078,0.836-1.694,1.056 c-0.616,0.22-1.349,0.33-2.2,0.33c-0.44,0-0.88-0.029-1.32-0.088c-0.44-0.06-0.865-0.162-1.276-0.309v-3.432 c0.352,0.117,0.711,0.234,1.078,0.352s0.741,0.177,1.122,0.177c0.763,0,1.379-0.177,1.849-0.528c0.469-0.353,0.88-0.865,1.231-1.54 l1.54-3.828l-9.02-22.616h4.224l6.644,18.612h0.088l6.38-18.612h3.96l-9.9,25.74C137.343,35.588,136.909,36.526,136.484,37.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.9434,
    y1: 8.7334,
    x2: 176.9434,
    y2: 31.4819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    display: "none",
    fill: "url(#SVGID_8_)",
    d: "M181.65,31.481l-4.619-18.084h-0.089l-4.575,18.084h-4.049l-7.304-22.748h4.136 l5.148,18.612h0.088l4.576-18.612h4.092l4.752,18.612h0.088l5.104-18.612h3.873l-7.26,22.748H181.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.0439,
    y1: 8.2061,
    x2: 204.0439,
    y2: 31.9663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    display: "none",
    fill: "url(#SVGID_9_)",
    d: "M210.879,30.029c-1.701,1.292-3.843,1.937-6.424,1.937 c-1.818,0-3.395-0.294-4.729-0.88c-1.335-0.587-2.457-1.408-3.366-2.464c-0.91-1.057-1.592-2.317-2.046-3.784 c-0.455-1.467-0.712-3.065-0.771-4.796c0-1.73,0.265-3.314,0.793-4.752c0.527-1.438,1.268-2.685,2.222-3.74 c0.952-1.056,2.083-1.877,3.388-2.464s2.734-0.88,4.29-0.88c2.024,0,3.703,0.418,5.038,1.254c1.334,0.836,2.404,1.899,3.212,3.189 c0.807,1.292,1.364,2.699,1.673,4.225c0.307,1.525,0.432,2.978,0.373,4.355h-17.027c-0.029,0.998,0.088,1.943,0.352,2.838 c0.264,0.896,0.689,1.688,1.275,2.376c0.587,0.689,1.335,1.24,2.244,1.65c0.909,0.411,1.98,0.616,3.213,0.616 c1.584,0,2.881-0.367,3.894-1.101c1.013-0.732,1.679-1.848,2.002-3.344h3.696C213.68,26.817,212.58,28.739,210.879,30.029z  M209.978,15.422c-0.337-0.792-0.792-1.474-1.364-2.046c-0.572-0.572-1.247-1.026-2.023-1.364 c-0.777-0.337-1.636-0.506-2.574-0.506c-0.969,0-1.842,0.169-2.618,0.506c-0.777,0.338-1.445,0.8-2.002,1.386 c-0.558,0.587-0.997,1.27-1.319,2.046c-0.324,0.778-0.514,1.606-0.572,2.486h13.067C210.512,17.05,210.314,16.214,209.978,15.422z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.6992,
    y1: 0.0654,
    x2: 228.6992,
    y2: 31.9663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    display: "none",
    fill: "url(#SVGID_10_)",
    d: "M221.658,0.065v11.748h0.088c0.617-1.261,1.584-2.178,2.904-2.75 c1.32-0.572,2.772-0.857,4.356-0.857c1.76,0,3.292,0.323,4.598,0.968c1.306,0.646,2.391,1.518,3.257,2.618 c0.864,1.1,1.518,2.369,1.957,3.806c0.44,1.438,0.66,2.963,0.66,4.576s-0.213,3.139-0.638,4.576 c-0.426,1.438-1.071,2.691-1.937,3.762c-0.865,1.071-1.951,1.914-3.256,2.53c-1.305,0.615-2.823,0.924-4.554,0.924 c-0.558,0-1.181-0.06-1.87-0.176c-0.689-0.118-1.371-0.309-2.046-0.572s-1.313-0.623-1.914-1.078 c-0.602-0.454-1.107-1.019-1.519-1.694h-0.088v3.036h-3.739V0.065H221.658z M235.101,16.808c-0.278-1.012-0.704-1.914-1.276-2.706 c-0.571-0.792-1.305-1.422-2.199-1.892c-0.896-0.469-1.943-0.704-3.146-0.704c-1.262,0-2.332,0.25-3.212,0.748 c-0.88,0.499-1.599,1.151-2.155,1.958c-0.559,0.807-0.962,1.724-1.211,2.75c-0.249,1.027-0.373,2.068-0.373,3.124 c0,1.115,0.131,2.193,0.396,3.233c0.264,1.042,0.682,1.958,1.254,2.75c0.571,0.792,1.313,1.431,2.222,1.914 c0.909,0.484,2.01,0.727,3.301,0.727c1.29,0,2.368-0.249,3.233-0.748c0.864-0.499,1.562-1.158,2.09-1.98 c0.528-0.82,0.909-1.76,1.144-2.815c0.235-1.057,0.353-2.142,0.353-3.256C235.519,18.854,235.379,17.819,235.101,16.808z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.1992,
    y1: 4.207,
    x2: 164.1992,
    y2: 32.2339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M156.871,27.522c1.57,0.967,3.865,1.771,6.281,1.771c3.584,0,5.678-1.893,5.678-4.631 c0-2.536-1.449-3.986-5.113-5.396c-4.43-1.57-7.168-3.866-7.168-7.691c0-4.228,3.503-7.369,8.777-7.369 c2.779,0,4.793,0.645,6,1.329l-0.966,2.859c-0.886-0.483-2.698-1.289-5.154-1.289c-3.704,0-5.114,2.215-5.114,4.067 c0,2.537,1.651,3.785,5.396,5.234c4.59,1.772,6.926,3.986,6.926,7.974c0,4.188-3.101,7.812-9.504,7.812 c-2.617,0-5.476-0.765-6.926-1.731L156.871,27.522z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.8359,
    y1: 4.2075,
    x2: 184.8359,
    y2: 32.2344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M191.26,19.066h-10.551v9.785h11.758v2.939h-15.261V4.65h14.657V7.59h-11.154v8.577h10.551V19.066 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.8086,
    y1: 4.207,
    x2: 207.8086,
    y2: 32.2339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M220.212,17.938c0,9.343-5.678,14.295-12.604,14.295c-7.168,0-12.201-5.557-12.201-13.771 c0-8.617,5.355-14.255,12.604-14.255C215.42,4.207,220.212,9.885,220.212,17.938z M199.151,18.382 c0,5.798,3.142,10.993,8.657,10.993c5.558,0,8.698-5.114,8.698-11.275c0-5.396-2.818-11.033-8.657-11.033 C202.051,7.066,199.151,12.422,199.151,18.382z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#97C63A",
    d: "M236.633,7.755h-8.254V4.775h20.093v2.979h-8.295v24.161h-3.544V7.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97C63A",
    d: "M266.149,22.01c0,7.208-4.993,10.349-9.704,10.349c-5.275,0-9.343-3.865-9.343-10.026 c0-6.523,4.269-10.349,9.664-10.349C262.363,11.983,266.149,16.05,266.149,22.01z M250.687,22.211c0,4.269,2.456,7.49,5.919,7.49 c3.383,0,5.92-3.182,5.92-7.57c0-3.302-1.651-7.49-5.84-7.49C252.498,14.641,250.687,18.507,250.687,22.211z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97C63A",
    d: "M288.256,22.01c0,7.208-4.993,10.349-9.704,10.349c-5.275,0-9.343-3.865-9.343-10.026 c0-6.523,4.269-10.349,9.664-10.349C284.471,11.983,288.256,16.05,288.256,22.01z M272.793,22.211c0,4.269,2.457,7.49,5.92,7.49 c3.383,0,5.919-3.182,5.919-7.57c0-3.302-1.651-7.49-5.839-7.49S272.793,18.507,272.793,22.211z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97C63A",
    d: "M292.727,3.325h3.543v28.591h-3.543V3.325z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5f67094877fb8659169b5b5c969c7750.svg";
export { ForwardRef as ReactComponent };